import { connect } from "react-redux";
import { Ticket } from "components/Ticket";
import { getListTicket } from "actions/Ticket";

const mapStateToProps = (state) => ({
  Ticket: state.Ticket,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListTicket: (dataSearch) => dispatch(getListTicket(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Ticket);
